var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundFlagEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r43zf7ui6a)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "j9bfoa8r4b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#j9bfoa8r4b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.842 0H0v1.873l8.842 5.793V0zM0 6.403v2.44h3.723L0 6.402zM0 15.158v2.439l3.723-2.44H0zM24 1.873V0h-8.842v7.666L24 1.873zM24 17.597v-2.44h-3.723L24 17.598zM15.158 16.334V24H24v-1.873l-8.842-5.793zM24 8.842V6.403l-3.723 2.44H24zM0 22.127V24h8.842v-7.666L0 22.127z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 22.127v-1.871l-7.853-5.098h2.32L24 18.75v-1.153l-3.723-2.44H24v-1.262H13.895V24h1.263v-7.666L24 22.127zM0 13.895v1.263h3.723L0 17.597v1.772l6.487-4.211h2.32L0 20.875v1.252l8.842-5.793V24h1.263V13.895H0zM10.105 0H8.842v7.666L0 1.873v2.05l7.579 4.92h-2.32L0 5.427v.975l3.723 2.44H0v1.262h10.105V0zM24 10.105V8.842h-3.723L24 6.403V4.608l-6.522 4.234h-2.32L24 3.102v-1.23l-8.842 5.794V0h-1.263v10.105H24z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 13.895v-3.79H13.895V0h-3.79v10.105H0v3.79h10.105V24h3.79V13.895H24z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.487 15.158 0 19.368v1.507l8.807-5.717h-2.32zM16.147 15.158 24 20.256V18.75l-5.533-3.592h-2.32zM7.579 8.842 0 3.922v1.506l5.259 3.414h2.32zM17.478 8.842 24 4.608V3.102l-8.842 5.74h2.32z",
    fill: "#FF4B55"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "r43zf7ui6a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundFlagEn);
export default __webpack_public_path__ + "static/media/round-flag-en.b44a61ceb766afb397d7f62213b8d165.svg";
export { ForwardRef as ReactComponent };